import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

export const selectShowNps = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.NpsStore
  ],
  (store) => store
)
